import {
  ServiceUnavailableError,
  RateLimitExceeded,
  NotFoundError,
  ValidationError,
} from './errors'

// Error Messages for UI - matching Ruby backend responses
export const ROCKET_REACH_ERROR_MESSAGES = {
  RATE_LIMIT: 'Too many requests, please try again later',
  NOT_FOUND: 'No results found',
  SERVICE_UNAVAILABLE: 'Service temporarily unavailable',
  VALIDATION: 'There was an error with your search. Please try again.',
}

/**
 * Gets the appropriate error message based on error type - matching Rails backend logic
 * @param {Error} error - The error instance
 * @returns {string} - User-friendly error message
 */
export function getErrorMessage(error) {
  switch (error.constructor) {
    case RateLimitExceeded:
      return ROCKET_REACH_ERROR_MESSAGES.RATE_LIMIT

    case NotFoundError:
      return ROCKET_REACH_ERROR_MESSAGES.NOT_FOUND

    case ValidationError:
      // For validation errors, show the specific field messages
      if (error.validationErrors && error.validationErrors.length > 0) {
        return error.validationErrors.map(err => err.message).join(', ')
      }

      return ROCKET_REACH_ERROR_MESSAGES.VALIDATION

    default:
      return ROCKET_REACH_ERROR_MESSAGES.SERVICE_UNAVAILABLE
  }
}

/**
 * Maps HTTP errors to specific error types - only handles specific cases
 * @param {Error} error - The original error from the HTTP request
 * @returns {Error} - Classified error instance
 */
export function classifyError(error) {
  const statusCode = error.response?.status
  const responseData = error.response?.data

  // Only handle specific error types, everything else is ServiceUnavailableError
  switch (statusCode) {
    case 400:
      // Handle validation errors
      if (Array.isArray(responseData?.errors)) {
        return new ValidationError(responseData.errors)
      }
      return new ValidationError()

    case 429:
      return new RateLimitExceeded()

    case 404:
      return new NotFoundError()

    default:
      // All other cases get treated as generic service unavailable
      return new ServiceUnavailableError()
  }
}
